export interface SkinnerBoxApiData {
  canParticipate?: boolean;
  enabled?: boolean;
  claimableAmount?: string;
}

/**
 * Validates if claimable amount is valid
 */
export const isValidClaimableAmount = (amount: string | undefined): boolean => {
  if (!amount) return false;
  const numAmount = Number(amount);
  return !isNaN(numAmount) && numAmount > 0;
};

/**
 * Determines if SkinnerBox should be shown based on API data
 */
export const shouldShowFromApiData = (data: SkinnerBoxApiData | undefined): boolean => {
  if (!data) return false;
  
  const canParticipate = data.canParticipate === true;
  const enabled = data.enabled === true;
  const hasValidAmount = isValidClaimableAmount(data.claimableAmount);
  
  return canParticipate && enabled && hasValidAmount;
};

/**
 * Determines if SkinnerBox should be shown based on WebSocket data
 */
export const shouldShowFromWSData = (showFromWS: boolean, wsAmount: number | null): boolean => {
  return showFromWS && wsAmount !== null && wsAmount > 0;
};

/**
 * Calculates final claimable amount from API or WS data
 */
export const calculateFinalClaimableAmount = (
  wsAmount: number | null,
  apiAmount?: string
): number => {
  // Prioritize WS amount if available
  if (wsAmount !== null && wsAmount > 0) {
    return wsAmount;
  }
  
  // Fallback to API amount
  if (apiAmount) {
    const amount = Number(apiAmount);
    return isNaN(amount) ? 0 : amount;
  }
  
  return 0;
};
